/**todo
 * @charset UTF-8
 * @Version 1.0.0
 * @接口
 * @name GuanPengfei
 * **/
export default {
    sendApplicationSmS:'/BaseData/SendApplicationSms',
    application:'/BaseData/Application',
    uploadFile:{
        //上传图片
        /**
         * 'fileStr'=> //图片流 base64
         *      'suffix'=>  //图片后缀
         */
        uploadImage:'/BaseData/ImageUpload'
    }
}



// WEBPACK FOOTER //
// ./src/common/api.js